module.exports = __webpack_public_path__ + "img/paymentBlack.26966351.svg";